.janeGoldDetailContainer {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.janeGoldDetailMain {
  margin-left: 16px;
  margin-right: 16px;
}

.termsModal {
  height: auto;
  max-height: 400px;
  padding: 40px;
}

.termsModal__header {
  box-shadow: none;
  padding: 0;
  min-height: auto;
  margin-bottom: 24px;
}

.termsModal__header > div {
  flex-direction: row-reverse;
}

.termsModal__header > div > div {
  margin: 0;
}

.termsModal__content {
  padding: 0;
}

.janeGoldInfoBoxMini {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;

  /* header height */
  height: 80px;

  /* header z-index is 200 */
  z-index: 201;
  background: white;
  padding: 16px;
  opacity: 0;
  transform: translateY(-100%);
  transition:
    opacity 0.3s ease-in-out,
    transform 0.3s ease-in-out;
  pointer-events: none;
}

.janeGoldInfoBoxMini.visible {
  opacity: 1;
  transform: translateY(0);
  pointer-events: auto;
}

.janeGoldInfoBoxMiniContent {
  justify-content: space-between;
  align-items: center;
  max-width: 100%;
  margin: 0 16px;
  height: 100%;
  vertical-align: middle;
}

.janeGoldMiniText {
  align-items: center;
}

.goldInfoBoxBrandLogo {
  height: 48px;
  width: 48px;
}

.janeGoldDetailBreadcrumbs {
  /* stylelint-disable-next-line declaration-no-important */
  margin-top: 8px !important;
}

@media all and (--reefer-media-tablet-min) {
  .janeGoldInfoBoxMini {
    display: none;
  }

  .janeGoldDetailContainer {
    flex-direction: row;
    gap: 32px;
    margin-top: 24px;
  }

  .janeGoldDetailMain {
    margin-left: 64px;
    margin-right: 64px;
  }

  .janeGoldDetailBreadcrumbs {
    /* stylelint-disable-next-line declaration-no-important */
    margin-top: 16px !important;
    margin-bottom: 24px;
  }
}
